import { render, staticRenderFns } from "./ListNewsletters.vue?vue&type=template&id=2044ad3e&scoped=true&"
import script from "./ListNewsletters.vue?vue&type=script&lang=js&"
export * from "./ListNewsletters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044ad3e",
  null
  
)

export default component.exports